import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=2110a5cb&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2110a5cb')) {
      api.createRecord('2110a5cb', component.options)
    } else {
      api.reload('2110a5cb', component.options)
    }
    module.hot.accept("./gallery.vue?vue&type=template&id=2110a5cb&", function () {
      api.rerender('2110a5cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/gallery/gallery.vue"
export default component.exports